import { axios } from "../http-common";

class Transfer {
  transferList(data) {
    return axios.get("v1/member/transfer/transfer-list", { params: data });
  }
  submitTransfer(data) {
    return axios.post("v1/member/transfer/launch-transfer", data);
  }
}

export default new Transfer();
